/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import TransactionSchema from './TransactionSchema.mjs'

const InvoiceSchema = new Schema({
  reference: {
    type: 'string',
    maxLength: 20,
    required: true
  },
  dueAt: {
    type: 'string',
    format: 'date-time',
    required: true
  },
  paidAt: {
    type: 'string',
    format: 'date-time'
  },
  paid: {
    type: 'boolean'
    // required: true
  },
  type: {
    type: 'string',
    maxLength: 30,
    required: true
  },
  total: {
    type: 'number',
    required: true
  },
  cps: {
    type: 'number',
    required: true
  },
  vat: {
    type: 'number',
    required: true
  },
  tmpRef: {
    type: 'string'
  },
  customerId: {
    type: 'number',
    required: true
  },
  estateId: {
    type: 'number',
    required: true
  },
  leaseId: {
    type: 'number'
  },
  Transactions: {
    type: 'array',
    items: {
      type: TransactionSchema.pick([
        'id',
        'category',
        'expense',
        'paid',
        'label',
        'amount',
        'vat',
        'cps',
        'interventionId'
      ])
    }
  }
})

export default InvoiceSchema
